import React from 'react';
import Joyride from 'react-joyride';
import IntroTourData from 'constants/IntroTourData';

class Tour extends React.PureComponent {
    static defaultProps = {
        joyride: {
            autoStart: false,
            resizeDebounce: false,
            run: false
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            step: 0
        };

        this.handleNextButtonClick = this.handleNextButtonClick.bind(this);
        this.handleJoyrideCallback = this.handleJoyrideCallback.bind(this);
    }

    handleNextButtonClick() {
        if (this.state.step === 1) {
            this.joyride.next();
        }
    }

    handleJoyrideCallback(result) {
        const { joyride } = this.props;
        if (result.type === 'step:before') {
            // Keep internal state in sync with joyride
            this.setState({ step: result.index });
        }

        if (result.action === 'close') {
            this.setState({ run: false });
            this.props.onReset();
        }

        if (result.type === 'finished' && this.state.run) {
            // Need to set our running state to false, so we can restart if we click start again.
            this.setState({ run: false });
            this.props.onReset();
        }

        if (result.type === 'error:target_not_found') {
            this.setState({
                step: result.action === 'back' ? result.index - 1 : result.index + 1,
                autoStart: result.action !== 'close' && result.action !== 'esc'
            });
        }

        if (typeof joyride.callback === 'function') {
            joyride.callback();
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.showTour && this.props.showTour) {
            this.setState({ step: 0 });
            setTimeout(() => {
                this.setState({
                    run: true
                });
            }, 500);
        }
    }

    getSteps() {
        switch (this.props.tourPage) {
            case 'dashboard':
                return IntroTourData.dashboard;
            case 'report-table':
                return IntroTourData['report-table'];
            case 'report-map':
                return IntroTourData['report-map'];
            case 'report-archive':
                return IntroTourData['report-archive'];
            case 'report':
                return IntroTourData.report;
            default:
                return [];
        }
    }

    render() {
        const { joyride } = this.props;
        const joyrideProps = {
            autoStart: true,
            callback: this.handleJoyrideCallback,
            debug: false,
            disableOverlay: this.state.step === 1,
            resizeDebounce: joyride.resizeDebounce,
            run: this.state.run,
            scrollToFirstStep: true,
            stepIndex: this.state.step,
            steps: this.getSteps(),
            type: 'continuous',
            styles: {
                options: {
                    arrowColor: '#e3ffeb',
                    backgroundColor: '#e3ffeb',
                    overlayColor: 'rgba(79, 26, 0, 0.4)',
                    primaryColor: '#0f0',
                    textColor: '#f0f'
                }
            },
            locale: {
                back: 'Zurück',
                close: 'Schließen',
                last: 'Tour beenden',
                next: 'Nächster Hinweis',
                skip: 'Überspringen'
            }
        };

        return <Joyride {...joyrideProps} ref={c => (this.joyride = c)} />;
    }
}

export default Tour;



// WEBPACK FOOTER //
// ./components/Tour/index.js